import { mediamarkttheme } from '@jotta/ui/themes/mediamarkt'
import { startApp } from '../App'

startApp(mediamarkttheme)
